<template>
     <v-app>
    <div class="all darker">
      <top-nav-bar></top-nav-bar>
      <router-view class="padding-top-nav" />
    </div> 
  </v-app>
</template>

<script>
import TopNavBar from './components/Navigation/TopNavBar.vue'

export default {
  name: 'App',
  components: {
    TopNavBar
  },
};
</script>

<style>
.all {
  min-height: 100vh;
}
.padding-top-nav {
  padding-top: 64px;
}
.pointer {
  cursor: pointer;
}
</style>